import { Injectable, NgZone } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ArkoseService } from './arkose.service';

@Injectable()
export class ArkoseInterceptor implements HttpInterceptor {

  private readonly headerName = 'X-DEFENSE-ARKOSE-TOKEN';
  private readonly retryHeader = 'X-ARKOSE-RETRY';
  private requestQueue: Promise<any> = Promise.resolve();

  constructor(private arkose: ArkoseService, private zone: NgZone) { }

  // The Arkose SDK resolves its callbacks outside the Angular zone, so every
  // emission below is re-entered explicitly or subscribers never trigger change detection.
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.headers.has(this.retryHeader)) {
      return next.handle(req);
    }

    return new Observable(observer => {
      this.requestQueue = this.requestQueue.then(() => {
        return next.handle(req).toPromise().then(
          event => {
            this.zone.run(() => {
              observer.next(event);
              observer.complete();
            });
          }
        ).catch(async (error: HttpErrorResponse) => {
          console.log('Interceptor caught error →', {
            url: req.url,
            status: error.status,
            rawError: error.error
          });
          let errorBody: any = error.error;

          if (typeof errorBody === 'string') {
            try {
              errorBody = JSON.parse(errorBody);
            } catch (e) {
              console.log('Error parsing string error body');
            }
          }
          const errorCode =
            errorBody?.errorcode ||
            errorBody?.errorCode ||
            errorBody?.messageId;
          console.log('Parsed errorCode →', errorCode);
          if (error.status === 401 && Number(errorCode) === 1018) {
            console.log('Arkose required → running challenge');

            try {
              const token = await this.arkose.getToken();
              console.log('Arkose token generated →', token);

              const retryReq = req.clone({
                setHeaders: {
                  [this.headerName]: token,
                  [this.retryHeader]: 'true'
                }
              });

              console.log('Retrying request with Arkose token');

              return next.handle(retryReq).toPromise().then(
                event => {
                  this.zone.run(() => {
                    observer.next(event);
                    observer.complete();
                  });
                }
              ).catch((retryError: HttpErrorResponse) => {
                this.zone.run(() => observer.error(retryError));
              });
            } catch (arkoseError) {
              this.zone.run(() => observer.error(arkoseError));
            }
            return;
          }

          this.zone.run(() => observer.error(error));
        });

      }).catch(() => {
        console.warn('Queue recovered after error');
      });

    });
  }
}
